export default __webpack_public_path__ + "static/media/k-video.6a65c0a0.png";